import { render, staticRenderFns } from "./FormChiTietAnPham.vue?vue&type=template&id=03f7633b&scoped=true"
import script from "./FormChiTietAnPham.vue?vue&type=script&lang=js"
export * from "./FormChiTietAnPham.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f7633b",
  null
  
)

export default component.exports